import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import useNavigate from '../../../../hooks/useNavigate';
import STRING_KEYS from '../../../../language/keys';
import HeaderNavigator from '../../../../components/HeaderNavigator';

interface BreadCrumbsProps {
  isNew: boolean
}

const BreadCrumbs:FC<BreadCrumbsProps> = ({
  isNew,
}): JSX.Element => {
  const { t: translate } = useTranslation();
  const { goToTalents } = useNavigate();
  const navElements = [{
    title: translate(STRING_KEYS.TALENTS_PAGE_TITLE),
    onClick: goToTalents,
  }, {
    title: isNew ?
      translate(STRING_KEYS.NEW_TALENT) :
      translate(STRING_KEYS.TALENT_EDITOR_BREADCRUMBS_TITLE),
    current: true,
  }];

  return (
    <HeaderNavigator elements={ navElements } />
  );
};

export default BreadCrumbs;
